export function isRoomNameValid(input: string): boolean {
  return (/^([a-zA-Z0-9]+)-(.+)$/u).test(input);
}

export function isDisplayNameValid(displayName: string): boolean {
  return displayName && displayName.length >= 2;
}
